module.exports = __webpack_public_path__ + "img/paper-default.a642d2de.png";